<div class="loader-container {{containerCustomStyle}}"
     [class.loader-container--fullscreen]="fullScreen">
  @if (spinnerStyle() === 'singleRing') {
    <div class="single-ring-loader {{customStyle}}"></div>
  } @else {
    <svg class="circular-loader {{customStyle}}"
         viewBox="25 25 50 50">
      <circle class="loader-path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              stroke-width="2"/>
    </svg>
  }
</div>

@if (currentMessage(); as message) {
  <div class="loader-message">
    @for (index of [currentMessageIndex()]; track index) {
      <span class="loader-message__text"
            [style.--loader-message-duration.ms]="messageCycleMS()">{{ message }}</span>
    }
  </div>
}